import React from 'react';
import { observer } from 'mobx-react-lite';

export const SaveToJsonButton = observer(({ store }) => {
  const saveToJson = () => {
    const json = store.toJSON(); // Get the JSON representation of the design
    const blob = new Blob([JSON.stringify(json)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'design.json';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <button onClick={saveToJson}>
      Save to JSON
    </button>
  );
});

